import { createRouter, createWebHistory } from "vue-router";
import Login from "@/views/Login/index.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import Dashboard from "@/views/DashBoard/index.vue";
import Analytics from "@/views/Analytics/index.vue";
import Settings from "@/views/Settings/index.vue";
import { getToken } from "@/stores/auth";

const routes = [
  { path: "/", component: Login },
  {
    path: "/",
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: "dashboard", component: Dashboard },
      { path: "analytics", component: Analytics },
      { path: "settings", component: Settings },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = getToken();
  if (to.meta.requiresAuth && !isAuthenticated) {
    next("/");
  } else {
    next();
  }
});

export default router;
